(() => {
  const initialize = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('[data-library-filters]');
    const cards = Array.from(root.querySelectorAll('[data-lesson]'));
    const count = root.querySelector('[data-library-count]');
    const empty = root.querySelector('[data-library-empty]');
    const pager = root.querySelector('[data-library-pagination]');
    const previous = root.querySelector('[data-library-previous]');
    const next = root.querySelector('[data-library-next]');
    const pageLabel = root.querySelector('[data-library-page]');
    const pageLinks = root.querySelector('[data-library-pages]');
    const pageTemplate = root.querySelector('[data-library-page-template]');
    const currentTemplate = root.querySelector('[data-library-current-template]');
    const pageSize = Number(root.dataset.pageSize) || 12;
    const filterButtons = Array.from(form.querySelectorAll('[data-library-filter]'));
    root.querySelectorAll('[data-library-scroll]').forEach((scroller) => {
      const measure = () => {
        const atEnd = scroller.scrollWidth - scroller.clientWidth - scroller.scrollLeft < 2;
        scroller.parentElement.classList.toggle('is-at-end', atEnd);
      };
      scroller.addEventListener('scroll', measure, {passive: true});
      if ('ResizeObserver' in window) new ResizeObserver(measure).observe(scroller);
      else window.addEventListener('resize', measure);
      requestAnimationFrame(measure);
    });
    const normalize = (value) => value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
    const records = cards.map((element) => ({element, tags: element.dataset.tags.split('|').map(normalize), search: element.dataset.search.toLowerCase()}));
    let page = 1;
    const loadUrl = () => {
      const params = new URLSearchParams(location.search);
      ['q', 'difficulty', 'category'].forEach((name) => {
        form.elements[name].value = params.get(name) || '';
      });
      page = Math.max(1, Number(params.get('lesson_page')) || 1);
    };
    const pageUrl = (number) => {
      const url = new URL(location.href);
      ['q', 'difficulty', 'category'].forEach((name) => {
        const value = form.elements[name].value.trim();
        if (value) url.searchParams.set(name, value);
        else url.searchParams.delete(name);
      });
      if (number > 1) url.searchParams.set('lesson_page', String(number));
      else url.searchParams.delete('lesson_page');
      return url;
    };
    const update = (writeUrl) => {
      const words = form.elements.q.value.toLowerCase().trim().split(/\s+/).filter(Boolean);
      const resetFilters = words.length > 0 && (form.elements.difficulty.value !== '' || form.elements.category.value !== '');
      if (resetFilters) {
        form.elements.difficulty.value = '';
        form.elements.category.value = '';
      }
      const level = form.elements.difficulty.value;
      const category = form.elements.category.value;
      filterButtons.forEach((button) => {
        const selected = form.elements[button.dataset.libraryFilter].value === button.dataset.libraryValue;
        button.setAttribute('aria-pressed', String(selected));
        const scroller = button.parentElement;
        if (selected && scroller.clientWidth > 0) {
          if (button.offsetLeft < scroller.scrollLeft) scroller.scrollLeft = button.offsetLeft;
          else if (button.offsetLeft + button.offsetWidth > scroller.scrollLeft + scroller.clientWidth) scroller.scrollLeft = button.offsetLeft + button.offsetWidth - scroller.clientWidth;
        }
      });
      const matches = records.filter((record) => (!level || record.tags.includes(level)) && (!category || record.tags.includes(category)) && words.every((word) => record.search.includes(word)));
      const pages = Math.max(1, Math.ceil(matches.length / pageSize));
      page = Math.min(page, pages);
      cards.forEach((card) => { card.hidden = true; });
      matches.slice((page - 1) * pageSize, page * pageSize).forEach((record) => { record.element.hidden = false; });
      count.textContent = `${count.dataset.countLabel}: ${matches.length}`;
      empty.hidden = matches.length > 0;
      pager.hidden = matches.length <= pageSize;
      previous.hidden = page === 1;
      next.hidden = page === pages;
      previous.href = pageUrl(page - 1);
      next.href = pageUrl(page + 1);
      previous.dataset.libraryPageNumber = String(page - 1);
      next.dataset.libraryPageNumber = String(page + 1);
      const numbers = Array.from({length: pages}, (_, index) => index + 1).filter((number) => number === 1 || number === pages || Math.abs(number - page) <= 2);
      const items = [];
      const addPage = (number) => {
        const item = (number === page ? currentTemplate : pageTemplate).content.firstElementChild.cloneNode(true);
        if (number === page) item.textContent = String(number);
        else {
          item.href = pageUrl(number);
          item.dataset.libraryPageNumber = String(number);
          item.setAttribute('aria-label', item.getAttribute('aria-label').replace('__PAGE__', String(number)));
          item.querySelector('[data-text]').textContent = String(number);
        }
        items.push(item);
      };
      numbers.forEach((number, index) => {
        const gap = number - numbers[index - 1];
        if (gap === 2) addPage(number - 1);
        else if (gap > 2) {
          const dots = document.createElement('span');
          dots.className = 'page flex items-center justify-center rounded-full';
          dots.textContent = '…';
          items.push(dots);
        }
        addPage(number);
      });
      pageLinks.replaceChildren(...items);
      pageLabel.textContent = `${pageLabel.dataset.pageLabel} ${page} ${pageLabel.dataset.ofLabel} ${pages}`;
      if (writeUrl || resetFilters) {
        history.replaceState(null, '', pageUrl(page));
      }
    };
    form.addEventListener('submit', (event) => { event.preventDefault(); page = 1; update(true); });
    form.addEventListener('input', () => { page = 1; update(true); });
    form.addEventListener('change', () => { page = 1; update(true); });
    form.addEventListener('click', (event) => {
      const button = event.target.closest('[data-library-filter]');
      if (!button || !form.contains(button)) return;
      form.elements.q.value = '';
      form.elements[button.dataset.libraryFilter].value = button.dataset.libraryValue;
      page = 1;
      update(true);
    });
    pager.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-library-page-number]');
      if (!link || !pager.contains(link) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      page = Number(link.dataset.libraryPageNumber);
      update(true);
      root.querySelector('[data-library-grid]').scrollIntoView({block: 'start'});
    });
    window.addEventListener('popstate', () => { loadUrl(); update(false); });
    window.matchMedia('(max-width: 768px)').addEventListener('change', () => update(false));
    form.hidden = false;
    loadUrl();
    update(false);
  };
  const initializeAll = (scope) => scope.querySelectorAll('[data-tutorial-library]').forEach(initialize);
  initializeAll(document);
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
